import React from "react";
import { footerContent } from "../../../../../cms";

const Footer = () => {
  return (
    <div>
      <footer className="py-5 bg-dark">
        <div className="container">
          <p className="m-0 text-center text-white">{footerContent.copyright}</p>
        </div>
      </footer>
    </div>
  );
};
export default Footer;
